var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.32878 12.1177V10.3341C5.32878 9.87875 5.7006 9.50964 6.15925 9.50964H7.83585C8.05611 9.50964 8.26734 9.5965 8.42308 9.75111C8.57882 9.90572 8.66632 10.1154 8.66632 10.3341V12.1177C8.66493 12.307 8.7397 12.4891 8.87405 12.6234C9.00839 12.7577 9.19119 12.8333 9.38188 12.8333H10.5257C11.0599 12.8347 11.5728 12.625 11.951 12.2504C12.3293 11.8759 12.5418 11.3674 12.5418 10.837V5.75563C12.5418 5.32723 12.3505 4.92087 12.0195 4.64602L8.12834 1.56088C7.45146 1.01995 6.48165 1.03742 5.82497 1.60236L2.02259 4.64602C1.67593 4.91277 1.46873 5.32033 1.4585 5.75563V10.8318C1.4585 11.9372 2.36114 12.8333 3.4746 12.8333H4.59233C4.98838 12.8333 5.31024 12.5161 5.31311 12.1229L5.32878 12.1177Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.e548a213f80590fe8b4aec3f135cc652.svg";
export { ForwardRef as ReactComponent };